import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor( private router:Router) { }

  ngOnInit(): void {
    
  }
  policy(){
    this.router.navigate(['/policy-privacy']);
  }
  terms(){
    this.router.navigate(['/terms-conditions']);
  }
  submit(){
alert('out Support team will contact with you shortly ... Thank You!!')
  }
}
